import { staffApis } from '@apis/dashboard/staffApis';
import { useMutation } from '@hooks/useMutation';

export const useStaffDelete = () => {
  return useMutation(async (id: number) => {
    const response = await staffApis.delete('/dashboard/staff/{id}/', {
      path: { id },
    });
    return response[204];
  }, {});
};
